import React from "react";
import { MEALS, WEEK_DAYS } from "../../lib/onboardingSchema";

const Row = ({ v = {}, onChange, testid }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: 8 }}>
    {MEALS.map(([k, l]) => (
      <label key={k} style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, color: "#a3a3a3" }}>
        {l}
        <input type="time" className="emp-input" style={{ padding: 10 }} value={v[k] || ""} onChange={(e) => onChange({ ...v, [k]: e.target.value })} data-testid={`${testid}-${k}`} />
      </label>
    ))}
  </div>
);

export const MealTimes = ({ value = {}, onChange, testid }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    <Row v={value.default} onChange={(d) => onChange({ ...value, default: d })} testid={`${testid}-default`} />
    <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, color: "#e5e5e5", cursor: "pointer" }}>
      <input type="checkbox" checked={!!value.varies} onChange={(e) => onChange({ ...value, varies: e.target.checked })} data-testid={`${testid}-varies`} />
      Mi horario cambia según el día
    </label>
    {value.varies && WEEK_DAYS.map((d) => (
      <div key={d} style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{d}</div>
        <Row v={value.days?.[d] || value.default} onChange={(x) => onChange({ ...value, days: { ...(value.days || {}), [d]: x } })} testid={`${testid}-${d.slice(0, 2).toLowerCase()}`} />
      </div>
    ))}
  </div>
);
